// @flow
import React from 'react';

type Props = {
  text?: string,
  iconName?: string,
  className: string,
  children?: any,
  onClose?: (evt: Event) => void
}

const Message = ({ text, children, onClose, iconName, className } : Props) => (
  <div className={`message ${className}`}>
    {iconName ? <i className={`icon ${iconName}`} /> : ''}
    <p className='text'>{text || children }</p>
    {onClose ? <span className='delete' onClick={onClose} role='button' tabIndex={0} /> : ''}
  </div>
);

export default Message;



// WEBPACK FOOTER //
// ./src/components/shared/Message.js